export default __webpack_public_path__ + "static/media/eyeliner.b458c39b.jpg";